import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { useLocation, useNavigationType, createRoutesFromChildren, matchRoutes, } from 'react-router';
import { normalizeTransactionName } from './normalizeTransactionName';
export const monitoringInit = () => {
    const logLevels = ['debug', 'info', 'log', 'warning', 'error', 'fatal'];
    if (window.REACT_APP_VKHRTEK_SENTRY_URL) {
        try {
            Sentry.init({
                dsn: window.REACT_APP_VKHRTEK_SENTRY_URL,
                tunnel: '/sentry-tunnel',
                release: `v${window.REACT_APP_VKHRTEK_RELEASE}`,
                integrations: [
                    Sentry.reactRouterV6BrowserTracingIntegration({
                        useEffect,
                        useLocation,
                        useNavigationType,
                        createRoutesFromChildren,
                        matchRoutes,
                    }),
                ],
                environment: window.REACT_APP_VKHRTEK_ENVIRONMENT,
                initialScope: {
                    level: 'fatal',
                    tags: {
                        vkdoc_error_type: 'unknown',
                    },
                },
                normalizeDepth: 10,
                tracesSampleRate: 1.0,
                ignoreErrors: [/\[http\] \[404\] GET .*\/company\/logo/],
                beforeSendTransaction: (event) => {
                    var _a;
                    if (event.type === 'transaction' && event.transaction) {
                        const normalized = normalizeTransactionName(event.transaction);
                        if (normalized !== event.transaction) {
                            event.transaction = normalized;
                        }
                    }
                    if (event.type === 'transaction' &&
                        ((_a = event.tags) === null || _a === void 0 ? void 0 : _a.vkdoc_error_type) === 'unknown' &&
                        event.level === 'fatal') {
                        delete event.tags.vkdoc_error_type;
                        event.level = 'info';
                    }
                    if (logLevels.indexOf(event.level || '') <
                        logLevels.indexOf(window.REACT_APP_VKHRTEK_LOG_LEVEL)) {
                        return null;
                    }
                    return event;
                },
            });
        }
        catch (_a) { }
    }
};
